import React from 'react';
import { Link } from 'react-router-dom';
import ServiceHero from '../../components/services/ServiceHero';
import { Footer } from '../../components/Footer';
import { Check, Palmtree, Sun, Coffee } from 'lucide-react';

const ContentRetreatPage = () => {

  const packs = [
    {
      tier: '🥉',
      name: 'Content Creator Pack',
      price: 45000000,
      forWho: 'solo creators, beginner coaches, first professional content',
      days: [
        {
          day: 'DAY 1 — Brief & Launch',
          schedule: [
            { time: '9:00', title: 'Welcome & Setup', desc: 'Full installation, tech test, welcome coffee' },
            { time: '9:30', title: 'Filming Brief', desc: 'Filming plan discussion, topic and recording order organisation' },
            { time: '10:30–13:00', title: 'Filming Session 1', desc: '2 full episodes' },
            { time: '13:00–14:00', title: 'Lunch break', desc: 'Partner restaurant' },
            { time: '14:00–17:00', title: 'Filming Session 2', desc: '1 full episode' },
            { time: '17:00–18:00', title: 'Day 1 Review', desc: 'Rush review, adjustments for Day 2' }
          ]
        },
        {
          day: 'DAY 2 — Intensive Production',
          schedule: [
            { time: '9:00', title: 'Quick Setup', desc: 'Already configured from Day 1' },
            { time: '9:15–12:30', title: 'Filming Session 3', desc: '2 episodes' },
            { time: '12:30–13:30', title: 'Lunch break', desc: 'Partner restaurant' },
            { time: '13:30–17:00', title: 'Filming Session 4', desc: 'Bonus content, short formats, interviews' },
            { time: '17:00–18:00', title: 'Day 2 Review', desc: 'Rush review, Day 3 prep' }
          ]
        },
        {
          day: 'DAY 3 — Reels & Wrap',
          schedule: [
            { time: '9:00–12:00', title: 'Reels Filming', desc: 'Production of 9 reels (3 per episode)' },
            { time: '12:00–13:00', title: 'Lunch break', desc: 'Partner restaurant' },
            { time: '13:00–16:00', title: 'Export & Organization', desc: 'All files organized by episode' },
            { time: '16:00–17:00', title: 'Transcriptions', desc: '' },
            { time: '17:00–18:00', title: 'Final Review', desc: 'Full review with client, Google Drive delivery' }
          ]
        }
      ],
      deliverables: ['3 edited podcast episodes', '9 edited and optimized reels', 'All raw files organized by episode', 'Transcriptions of each episode', 'Google Drive delivery within 5 days']
    },
    {
      tier: '🥈',
      name: 'Brand Builder Pack',
      price: 75000000,
      forWho: 'infopreneurs, online trainers, established personal brands',
      popular: true,
      days: [
        {
          day: 'DAY 1 — Brief & Production',
          schedule: [
            { time: '8:30', title: 'Premium Welcome', desc: 'Full setup (3 cam + 4 mics), complete tech test' },
            { time: '9:00–9:30', title: 'Technical Brief', desc: 'Filming plan, topic organisation, camera and sound adjustments' },
            { time: '9:30–13:00', title: 'Filming Session 1', desc: '3 episodes' },
            { time: '13:00–14:00', title: 'Lunch break', desc: '' },
            { time: '14:00–17:30', title: 'Filming Session 2', desc: '2 episodes' },
            { time: '17:30–18:00', title: 'Day 1 Review', desc: '' }
          ]
        },
        {
          day: 'DAY 2 — Production & Live',
          schedule: [
            { time: '9:00–12:30', title: 'Filming Session 3', desc: '3 episodes' },
            { time: '12:30–13:30', title: 'Lunch break', desc: '' },
            { time: '13:30–15:00', title: 'Live Preparation', desc: 'Streaming test, rehearsal, graphics setup' },
            { time: '15:00–17:00', title: 'LIVE', desc: '2h stream — 1 platform (included in pack)' },
            { time: '17:00–18:00', title: 'Day 2 Review', desc: '' }
          ]
        },
        {
          day: 'DAY 3 — Reels & Finalization',
          schedule: [
            { time: '9:00–12:00', title: 'Reels Filming', desc: '15 reels production' },
            { time: '12:00–13:00', title: 'Lunch break', desc: '' },
            { time: '13:00–17:00', title: 'Additional Reels & Wrap', desc: 'Extra content, file organization' },
            { time: '17:00–18:00', title: 'Final Review', desc: 'Full review, Google Drive delivery' }
          ]
        }
      ],
      deliverables: ['6 edited podcast episodes', '15 edited and optimized reels', '1 streamed live + edited replay', 'Google Drive delivery within 7 days']
    },
    {
      tier: '🥇',
      name: 'Launch Machine Pack',
      price: 120000000,
      forWho: 'signature program launch, premium personal brand',
      days: [
        {
          day: 'DAY 1 — Shooting & Brief',
          schedule: [
            { time: '8:00', title: 'VIP Welcome', desc: 'Full premium setup, coffee, complete briefing' },
            { time: '8:30–12:00', title: 'Pro Photo Shooting', desc: 'Photos for sales page and social media' },
            { time: '12:00–13:00', title: 'Lunch break', desc: '' },
            { time: '13:00–17:00', title: 'Filming Session 1', desc: '4 premium episodes' },
            { time: '17:00–18:00', title: 'Day 1 Review', desc: '' }
          ]
        },
        {
          day: 'DAY 2 — Intensive Production & Launch Live',
          schedule: [
            { time: '8:30–12:30', title: 'Filming Session 2', desc: '4 episodes' },
            { time: '12:30–13:30', title: 'Lunch break', desc: '' },
            { time: '13:30–15:00', title: 'Live Preparation', desc: 'Full rehearsal, graphics, multi-platform test' },
            { time: '15:00–17:00', title: 'LAUNCH LIVE', desc: '2h stream — multi-platform' },
            { time: '17:00–18:00', title: 'Day 2 Review', desc: '' }
          ]
        },
        {
          day: 'DAY 3 — Marketing Content',
          schedule: [
            { time: '9:00–12:00', title: 'Reels Filming', desc: '20+ reels production' },
            { time: '12:00–13:00', title: 'Trailer Filming', desc: '2 min launch trailer' },
            { time: '13:00–14:00', title: 'Lunch break', desc: '' },
            { time: '14:00–16:00', title: 'VSL Filming', desc: 'Video Sales Letter for sales page (3–5 min)' },
            { time: '16:00–17:00', title: 'BTS + Finishing touches', desc: '' },
            { time: '17:00–18:00', title: 'VIP Final Review', desc: 'Full review, Google Drive delivery' }
          ]
        }
      ],
      deliverables: ['10 edited podcast episodes', '20+ edited and optimized reels', '1 multi-platform launch live + replay edited within 48h', 'Pro photo shoot — 20 retouched photos', '2 min launch trailer', 'VSL edited for sales page', 'Google Drive delivery within 10 days']
    }
  ];

  return (
    <div className="min-h-screen bg-[#0D0D0D] pt-24">
      <ServiceHero
        tag="CONTENT RETREAT"
        title="3-Day Intensive"
        description="A focused 3-day content production experience in paradise. Walk away with weeks of professional content."
        bookLink="/services/content-retreat/book"
        bookLabel="Book Your Retreat"
        heroImage="https://images.unsplash.com/photo-1586209085320-1c2ad35da852?w=1600&q=80"
        metaTitle="Content Retreat | Canggu Podcast Studio"
        metaDescription="3-day content creation retreat in Canggu, Bali. Podcast, video and photo production intensive with professional team."
      />

      {/* Packs */}
      {packs.map((pack, packIndex) => (
        <section key={packIndex} className={`py-16 ${packIndex % 2 === 0 ? 'bg-[#0A0A0A]' : ''}`}>
          <div className="max-w-6xl mx-auto px-6">
            <div className={`border ${pack.popular ? 'border-[#F5A623] bg-[#F5A623]/5' : 'border-[#262626] bg-[#121212]'} p-6 md:p-10 relative`}>
              {pack.popular && (
                <span className="absolute -top-3 left-8 px-4 py-1 bg-[#F5A623] text-black text-sm font-semibold">
                  MOST POPULAR
                </span>
              )}
              
              {/* Header */}
              <div className="flex flex-col md:flex-row md:items-center md:justify-between mb-8">
                <div>
                  <div className="flex items-center gap-3 mb-2">
                    <span className="text-3xl">{pack.tier}</span>
                    <h2 className="text-3xl font-heading font-semibold text-white">{pack.name}</h2>
                  </div>
                  <p className="text-gray-400">For: {pack.forWho}</p>
                </div>
                <div className="mt-4 md:mt-0 text-right">
                  <div className="text-4xl font-heading font-bold text-[#F5A623]">
                    Rp {(pack.price / 1000000).toFixed(0)}M
                  </div>
                </div>
              </div>

              {/* Days */}
              <div className="space-y-6 mb-8">
                {pack.days.map((day, dayIndex) => (
                  <div key={dayIndex}>
                    <h3 className="text-xl font-semibold text-white mb-4 flex items-center gap-2">
                      <Sun className="w-5 h-5 text-[#F5A623]" />
                      {day.day}
                    </h3>
                    <div className="space-y-2">
                      {day.schedule.map((item, i) => (
                        <div key={i} className="flex gap-4 p-3 bg-[#0D0D0D] border border-[#262626]">
                          <span className="text-[#F5A623] font-mono text-sm w-28 flex-shrink-0">{item.time}</span>
                          <div className="flex-1">
                            <span className="text-white font-medium">{item.title}</span>
                            {item.desc && <span className="text-gray-400 ml-2">— {item.desc}</span>}
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

              {/* Deliverables */}
              <div>
                <h3 className="text-xl font-semibold text-white mb-4">Deliverables</h3>
                <div className="grid md:grid-cols-2 gap-3">
                  {pack.deliverables.map((item, i) => (
                    <div key={i} className="flex items-start gap-3 p-3 bg-[#0D0D0D] border border-[#F5A623]/30">
                      <Check className="w-5 h-5 text-[#F5A623] mt-0.5 flex-shrink-0" />
                      <span className="text-gray-300">{item}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>
      ))}

      {/* CTA Section */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="font-heading text-3xl md:text-4xl text-white mb-4">
            Ready for Your Content Retreat?
          </h2>
          <p className="text-gray-400 mb-8">
            3 days in Bali, 3 months of content. Book your retreat now.
          </p>
          <Link
            to="/services/content-retreat/book"
            className="inline-block px-12 py-4 bg-[#F5A623] text-black font-semibold text-lg hover:bg-[#FFB84D] transition-colors"
            data-testid="book-now-cta"
          >
            Book Your Retreat
          </Link>
        </div>
      </section>

      
      {/* Footer */}
      <Footer />
    </div>
  );
};

export default ContentRetreatPage;
